import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import { STREAM_STATE, STREAM_TABS } from 'global/StreamWidget/constants';
import { useSelector } from 'react-redux';
import { selectors } from '../../slice';
import { NewIndicator } from '../styled';

const { Flex, Text } = Common;

interface NavigationTabProps {
  selectedTab: string;
  setSelectedTab: (value: string) => void;
  persistTab?: boolean;
  isNotified: boolean;
  removeNewIndicator: () => void;
}

type StreamTab = typeof STREAM_TABS[0];

function NavigationTab({
  selectedTab,
  setSelectedTab,
  persistTab = false,
  isNotified,
  removeNewIndicator,
}: NavigationTabProps) {
  const { hasNewResearch, newResearchCount } = useSelector(selectors);

  const handleTabChange = (item: StreamTab) => {
    setSelectedTab(item.value);

    if (item.value === 'research') {
      removeNewIndicator();
    }

    if (persistTab) {
      localStorage.setItem(STREAM_STATE.TAB, item.value);
    }
  };

  return (
    <>
      <Flex
        align="center"
        justify="flex-start"
        height="100%"
        style={{ gap: '16px' }}
      >
        {STREAM_TABS.map((tab) => {
          const active = selectedTab === tab.value;
          const suffix = active ? '-active' : '';
          const textColor = active ? color.primary : color.highgray;
          const border = active && `solid 1px ${color.primary}`;
          const showIndicator =
            tab.value === 'research' &&
            hasNewResearch &&
            newResearchCount > 0 &&
            selectedTab !== tab.value &&
            !isNotified;

          return (
            <Flex
              align="center"
              style={{
                gap: '8px',
                cursor: 'pointer',
                borderBottom: border,
                position: 'relative',
              }}
              onClick={() => handleTabChange(tab)}
              height="100%"
              padding="0 6px"
              key={tab.value}
              data-cy={tab.dataCy}
            >
              <Image src={`${tab.icon}${suffix}.svg`} />
              <Text color={textColor} family={active && 'bold'}>
                {tab.label}
              </Text>
              {showIndicator && (
                <NewIndicator larger={newResearchCount > 99}>
                  <span>
                    {newResearchCount > 99 ? '99+' : newResearchCount}
                  </span>
                </NewIndicator>
              )}
            </Flex>
          );
        })}
      </Flex>
    </>
  );
}

export default NavigationTab;
